import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getCommonData } from '../components/Main/actions';
import { confirmEmail } from '../components/EmailConfirmContent/actions'; 
import Header from '../components/Header/Header';
import EmailConfirmContent from '../components/EmailConfirmContent/EmailConfirmContent'; 


class EmailConfirm extends Component {
  constructor(props) {
    super(props);

    this.confirmEmail = this.confirmEmail.bind(this);
  }
  
  componentDidMount() {
    document.title = 'Potvrzení rezervace';

    if (this.props.logo.status === false) {
      this.props.getCommonData();
    }
      
    this.confirmEmail();
  }

  confirmEmail() {
    const { emailHash, } = this.props.params;

    this.props.confirmEmail(emailHash);
  }

  render() {
    const { confirmEmailData, logo, } = this.props;

    return (
      <div>

        <Header
          logoName={logo.fileName}
          office={null}
        />   

        <div className="container-fluid page-header">
          <EmailConfirmContent
            confirmEmailData={confirmEmailData}
            confirmEmail={this.confirmEmail}
          />
        </div>

      </div>
      
    );
  }
}


const mapStateToProps = (state) => {
  const { confirmEmail, } = state;
  return { 
    confirmEmailData: confirmEmail,
    logo: {
      status: state.main.status, 
      ...state.main.data.logo,
    }
   };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCommonData: bindActionCreators(getCommonData, dispatch),
    confirmEmail: bindActionCreators(confirmEmail, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirm);


// WEBPACK FOOTER //
// ./src/pages/EmailConfirm.js